import { render } from "./App.vue?vue&type=template&id=618a03c6&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=618a03c6&lang=css"

import exportComponent from "D:\\Github\\SmsAdminOnlineApplication\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__